import type { PharmacyNode, ScopeTreeResponse } from "./types";

/**
 * Buduje mape `idfirm -> nazwa apteki` z drzewa /scope/tree. Nazwy pochodza z
 * `farm_firm` (COALESCE(pharmacy_overrides.unitname, ff.fullname, ff.unitname))
 * — to samo zrodlo co etykiety w ScopePickerze, wiec spojne w calym UI.
 * Apteka moze wystepowac w kilku galeziach (wlasne/spolki/orphan) — Map z
 * natury deduplikuje po idfirm.
 */
export function buildPharmacyNameMap(tree?: ScopeTreeResponse): Map<number, string> {
	const map = new Map<number, string>();
	if (!tree) return map;
	const add = (pharmacies: PharmacyNode[]) => {
		for (const p of pharmacies) {
			if (p.name) map.set(p.idfirm, p.name);
		}
	};
	for (const region of tree.wlasne.regions) add(region.pharmacies);
	for (const spolka of tree.spolki) add(spolka.pharmacies);
	for (const orphan of tree.orphanGroups) add(orphan.pharmacies);
	return map;
}
